import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
	useAllDevicesQuery,
	useCreateDeviceMutation,
	useDeleteDeviceByIdMutation
} from '../../../store/api/device.api';
import styles from './DevicesAdminPage.module.css';
import { DeviceModal } from '../Modal/DeviceModal/DeviceModal';

export const DevicesAdminPage = () => {
	const navigate = useNavigate(); // ← инициализировать
	const { data: devices = [], isLoading, refetch } = useAllDevicesQuery();
	const [createMode, setCreateMode] = useState(false);
	const [searchQuery, setSearchQuery] = useState('');
	const [currentPage, setCurrentPage] = useState(1);

	const DEVICES_PER_PAGE = 20;

	const [createDevice] = useCreateDeviceMutation();
	const [deleteDevice] = useDeleteDeviceByIdMutation();

	const handleCloseModal = () => {
		setCreateMode(false);
	};

	const handleDeviceSubmit = async (name) => {
		try {
			await createDevice(name).unwrap();
			refetch();
		} catch (error) {
			alert('Ошибка при добавлении устройства');
		}
		handleCloseModal();
	};

	const handleDelete = async (deviceId) => {
		if (window.confirm('Вы уверены, что хотите удалить это устройство?')) {
			try {
				await deleteDevice(deviceId).unwrap();
				refetch();
			} catch (error) {
				alert('Ошибка при удалении устройства');
			}
		}
	};

	if (isLoading) {
		return <div className={styles.loading}>Загрузка...</div>;
	}

	const filteredDevices = devices.filter(device =>
		device?.name?.toLowerCase().includes(searchQuery.toLowerCase())
	);

	const totalPages = Math.ceil(filteredDevices.length / DEVICES_PER_PAGE);

	const handlePageChange = (newPage) => {
		if (newPage >= 1 && newPage <= totalPages) {
			setCurrentPage(newPage);
		}
	};

	const devicesToShow = filteredDevices.slice(
		(currentPage - 1) * DEVICES_PER_PAGE,
		currentPage * DEVICES_PER_PAGE
	);

	return (
		<div className={styles.main}>
			{/* Кнопка Назад */}
			<div className={styles.backWrapper}>
				<button className={styles.backButton} onClick={() => navigate('/admin')}>
					← Назад
				</button>
			</div>

			<h2 className={styles.title}>Устройства</h2>

			<div className={styles.buttonWrapper}>
				<button className={styles.addButton} onClick={() => setCreateMode(true)}>
					Добавить устройство
				</button>
			</div>

			<div className={styles.searchWrapper}>
				<input
					type="text"
					value={searchQuery}
					onChange={(e) => {
						setSearchQuery(e.target.value);
						setCurrentPage(1);
					}}
					placeholder="Поиск по названию..."
					className={styles.searchInput}
				/>
			</div>

			<div className={styles.header}>
				<div>ID</div>
				<div>Название</div>
				<div>Действия</div>
			</div>

			<div className={styles.list}>
				{devicesToShow.map((device) => (
					<div key={device.id} className={styles.row}>
						<div>{device.id}</div>
						<div>{device.name}</div>
						<div className={styles.actions}>
							<div onClick={() => handleDelete(device.id)} className={styles.menuIcon}>
								Удалить
							</div>
						</div>
					</div>
				))}
			</div>

			{totalPages > 1 && (
				<div className={styles.pagination}>
					<button
						onClick={() => handlePageChange(currentPage - 1)}
						disabled={currentPage === 1}
						className={styles.pageButton}
					>
						Назад
					</button>
					<span className={styles.pageInfo}>
						Страница {currentPage} из {totalPages}
					</span>
					<button
						onClick={() => handlePageChange(currentPage + 1)}
						disabled={currentPage === totalPages}
						className={styles.pageButton}
					>
						Вперёд
					</button>
				</div>
			)}

			{createMode && (
				<DeviceModal
					isOpen={createMode}
					onClose={handleCloseModal}
					onSubmit={handleDeviceSubmit}
				/>
			)}
		</div>
	);
};
